var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@13.7.3_babel-cor_d694245fa2f13794fad64f98c4d748e3/~/vue-loader/lib/template-compiler?{"id":"data-v-4e37de68","hasScoped":false,"buble":{"transforms":{}}}!./~/.pnpm/vue-loader@13.7.3_babel-cor_d694245fa2f13794fad64f98c4d748e3/~/vue-loader/lib/selector.js?type=template&index=0!./src/RealApp.vue
// module id = 235
// module chunks = 1